export const formatNoteDescriptionFromBackend = (description) => (description ? description.replaceAll('|', '\n') : '')

export const formatNoteDescriptionToBackend = (description) => (description ? description.replaceAll('\n', '|') : '')
